var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOilDerrick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-2{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162,116v-7.48a6.85,6.85,0,0,1,13.7,0v7.14ZM96.45,98.88V84.3a11.78,11.78,0,0,1,23.56,0V96.6m16.09,73.19L119.44,96.6H97L80.94,169.79M37.1,171.51H185.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.66,85.48A2.46,2.46,0,1,1,108.2,83a2.47,2.47,0,0,1,2.46,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.22,55.86a2.46,2.46,0,1,1-3.36.92,2.45,2.45,0,0,1,3.36-.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.73,75v95.93M67.83,45,50.73,75A7.13,7.13,0,0,1,41,77.66l-11.3-6.42L46.58,41.65A7.61,7.61,0,0,1,57,38.8Zm111.31,126H158.45V156.58h20.69Zm-10.39-55.1v39m-8.57-51.66L121.1,88.85M97,78.51,57.71,64.17m69.13,68.88L94.09,111.23m-4,20.67,32.18-20.67m11.5,51.66-46-22.38m-4.6,22.38,45.4-23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilDerrick);
export default __webpack_public_path__ + "static/media/OIL_DERRICK.5f1d2d68ed11f8630662d350b47ecdbb.svg";
export { ForwardRef as ReactComponent };